// extracted by mini-css-extract-plugin
module.exports = {"ErrorMessage":"ErrorBoundary_ErrorMessage__3m824","PreText":"ErrorBoundary_PreText__2pkR-"};